<template>
  <button
    :class="cssClasses"
    type="submit"
    :disabled="loading"
    @click="onClick"
  >
    {{ label }}
  </button>
</template>

<script>
  export default {
    props: {
      loading: { type: Boolean, default: false },
      defaultLabel: {
        type: String,
        default() {
          if (this.$slots.default && this.$slots.default.length > 0) {
            return this.$slots.default[0].text
          }
          return 'Submit'
        }
      },
      loadingLabel: { type: String, default: 'Loading ...' }
    },
    computed: {
      cssClasses() {
        if (this.loading) {
          return 'btn btn-secondary'
        }
        return 'btn btn-primary'
      },
      label() {
        if (this.loading) {
          return this.loadingLabel
        }
        return this.defaultLabel
      }
    },
    methods: {
      onClick(event) {
        this.$emit('click', event)
      }
    }
  }
</script>
